import { Button, Input } from '@chakra-ui/react';
import React, { useState } from 'react'
import {  useNavigate } from 'react-router-dom';

const Payment = () => {
   let [pay,setPay] = useState(false);
   let [msg,setMsg] =useState(false);
   let navigate = useNavigate()
    const handelPay=()=>{
       setPay(true);
       setTimeout(() => {
        setPay(false)
           setMsg(true);
       }, 3000);
   
    }

    const addProject=()=>{
        navigate("/home")
    }
  return (
    <div style={{height:"700px",margin:"100px  auto",width:"50%"}} >
        <Input type="text" placeholder='Cardholder name' /> <br /> <br />
        <Input type="number" placeholder="cvv" /> <br /> <br />
        <Input type="date" placeholder="Expirey date" /> <br /> <br />
        <Button onClick={handelPay} >Pay 💲</Button>
        {
            pay ? <img src='https://media.tenor.com/BntXpMlrGuEAAAAC/check-correct.gif' /> : ""
        }

        {
            msg ? <h1 style={{color:"green",fontSize:"30px",fontWeight:"bolder"}} > Payment Done  </h1> : ""
        }

        {
            msg ? <Button onClick={addProject} >Add Projects</Button> : ""
        }
    </div>
  )
}

export default Payment